import { v4 as uuidv4 } from 'uuid'

import {
  type FolderInitiatePlaceholder,
  initiateFolderTree,
  type InitiateFolderTreeError,
  type InitiateFolderTreeParams,
} from './useFolderUpload.helpers'
import { useGlobalFileUpload } from './useGlobalFileUpload'

type TrackingParams = InitiateFolderTreeParams & {
  clientRequestId?: string
}

export async function initiateFolderTreeWithTracking({
  clientRequestId,
  onBeforeInitiate,
  onInitiateError,
  ...rest
}: TrackingParams) {
  const { registerPendingFolderUpload, markFolderInitiateFailed } = useGlobalFileUpload.getState()
  const effectiveClientRequestId = clientRequestId ?? uuidv4()

  const handleBeforeInitiate = (placeholder: FolderInitiatePlaceholder) => {
    registerPendingFolderUpload?.({
      clientRequestId: placeholder.clientRequestId,
      name: placeholder.rootName,
      totalFiles: placeholder.totalFiles,
      totalBytes: placeholder.totalBytes,
      parentPath: placeholder.parentPath,
    })
    onBeforeInitiate?.(placeholder)
  }

  const handleInitiateError = (payload: InitiateFolderTreeError) => {
    markFolderInitiateFailed?.(payload)
    onInitiateError?.(payload)
  }

  const result = await initiateFolderTree({
    ...rest,
    clientRequestId: effectiveClientRequestId,
    onBeforeInitiate: handleBeforeInitiate,
    onInitiateError: handleInitiateError,
  })

  if (result && 'quotaExceeded' in result) {
    const errorMessage = result.errors?.[0] || 'Folder upload failed: storage quota exceeded.'

    markFolderInitiateFailed?.({
      clientRequestId: effectiveClientRequestId,
      errorMessage,
    })
  }

  return { result, clientRequestId: effectiveClientRequestId }
}
